export const STUDENT_NAV_TABS = [
  { label: "Dashboard", path: "/student" },
  { label: "Courses", path: "/student/courses" },
  { label: "Quiz", path: "/student/quiz" },
  { label: "Certification", path: "/student/certificates" },
  { label: "Wishlist", path: "/student/wishlist" },
  { label: "Settings", path: "/student/settings" },
];
